import { render, staticRenderFns } from "./user_settings.vue?vue&type=template&id=1b36f92e&scoped=true&"
import script from "./user_settings.vue?vue&type=script&lang=js&"
export * from "./user_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36f92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b36f92e')) {
      api.createRecord('1b36f92e', component.options)
    } else {
      api.reload('1b36f92e', component.options)
    }
    module.hot.accept("./user_settings.vue?vue&type=template&id=1b36f92e&scoped=true&", function () {
      api.rerender('1b36f92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/user_settings.vue"
export default component.exports